const INVENTORY_ITEM_SEARCH_KEYS = ["search", "page"] as const;

export const buildInventoryModalSearchParams = (variables: Record<string, any> = {}) => {
    const params: Record<string, any> = {};

    INVENTORY_ITEM_SEARCH_KEYS.forEach((key) => {
        const value = variables?.[key];
        if (value !== undefined && value !== null && value !== "") {
            params[key] = value;
        }
    });

    return {
        ...params,
        is_active: true,
        page_size: Number.MAX_SAFE_INTEGER,
    };
};
